<!--通用的图表组件-->
<template>
  <el-row>
    <div class="chart" :id="id">{{err_text}}</div>
    <div>
      <el-pagination
        :total="this.total"
        :current-page.sync="page"
        :page-size="pagesize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      ></el-pagination>
    </div>
    <div class="chart" style="padding: 40px 20px;" :id="id + 'pie'" v-if="isPie"></div>
  </el-row>
</template>

<script>
const { init } = require('echarts')

export default {
  name: 'BaseChart',
  props: [
    'chartUrl',
    'chartText',
    'want',
    'total',
    'type',
    'isPie'
  ],
  data () {
    return {
      id: this.chartUrl,
      page: 1,
      pagesize: 10,
      content: [],
      count: [],
      date: [],
      err_text: undefined
    }
  },
  computed: {
    url: function () {
      return this.getDomain() + 'bmsummary/get_' + this.chartUrl
    },
    Option: function () {
      return {
        title: {
          text: this.chartText,
          textStyle: {
            fontFamily: '"Microsoft YaHei", serif'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            if (this.type === 'percent') {
              return params[0].axisValue + '<br />' +
                params[0].seriesName + '<span>&emsp;' + (params[0].value).toFixed(2) + '%'
            } else {
              return params[0].axisValue + '<br />' +
                params[0].seriesName + '：' + params[0].value
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {title: '保存'}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.date
        },
        yAxis: {
          id: this.chartText,
          type: 'value',
          axisLabel: {
            formatter: value => {
              if (this.type === 'percent') {
                return value + ' %'
              } else {
                return value
              }
            }
          }
        },
        series: [
          {
            name: this.chartText,
            type: 'line',
            data: this.count,
            smooth: true
          }
        ]
      }
    }
  },
  methods: {
    getChart () {
      let params = {
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.content = res.data.content[this.chartUrl]
        let chart = init(document.getElementById(this.id))
        this.content.forEach(items => {
          if (items.date) {
            this.date.push(this.timeTransform(items.date, false))
          } else {
            this.date.push(items.year + '-' + (items.month < 10 ? '0' + items.month : items.month))
          }
          if (this.type === 'money') {
            this.count.push(items[this.want] / 100)
          } else if (this.type === 'percent') {
            this.count.push(items[this.want] * 100)
          } else {
            this.count.push(items[this.want])
          }
        })
        if (this.date[2] > this.date[3]) {
          this.date.reverse()
          this.count.reverse()
        }
        chart.setOption(this.Option)
        chart.on('click', params => {
          this.getPie(params)
        })
        this.date = []
        this.count = []
        if (this.isPie) {
          this.getPie({
            seriesName: this.chartText,
            name: this.getNow()
          })
        }
      }
      this.__axios(this.url, params, handle)
    },
    getPie (params) {
      let [ date, year, month, url, title ] = [ undefined, undefined, undefined, undefined, undefined ]
      if (params.seriesName === '日交易额') {
        let dateList = params.name.trim().split('-')
        date = new Date(dateList[0], dateList[1] * 1 - 1, dateList[2]).getTime() / 1000
        url = this.getDomain() + 'bmsummary/income_proportion_daily'
        title = params.name + '  流水分析'
      } else if (params.seriesName === '月交易额') {
        let dateList = params.name.split('-')
        year = dateList[0] * 1
        month = dateList[1] * 1
        url = this.getDomain() + 'bmsummary/income_proportion_monthly'
        title = params.name + '  流水分析'
      }
      if (url) {
        let time = {
          date: date,
          year: year,
          month: month
        }
        let handle = res => {
          let data = []
          let mapping = {
            txm_info: '团小蜜-团长-顾客',
            brander_info: '其他品牌商-团长-顾客',
            seller_info: '纯双边交易'
          }
          Object.keys(res.data.content).forEach(key => {
            data.push({
              value: res.data.content[key].order_price / 100,
              count: res.data.content[key].order_count,
              name: mapping[key]
            })
          })
          let options = {
            title: {
              text: title,
              left: 'center'
            },
            tooltip: {
              trigger: 'item',
              formatter: function (a) {
                return `${a.name} ： </br>${a.value}元 (${a.percent}%)</br> ${a.data.count}单`
              }
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: ['团小蜜-团长-顾客', '其他品牌商-团长-顾客', '纯双边交易']
            },
            series: [
              {
                name: '流水占比',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                label: {
                  show: false,
                  position: 'center'
                },
                data: data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          let chart = init(document.getElementById(this.id + 'pie'))
          chart.setOption(options)
        }
        this.__axios(url, time, handle)
      }
    },
    getNow () {
      let now = new Date()
      if (this.chartText === '日交易额') {
        return this.timeTransform(now / 1000, false)
      } else if (this.chartText === '月交易额') {
        return now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2)
      }
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.page = 1
      this.getChart()
    },
    handleCurrentChange (val) {
      this.page = val
      this.getChart()
    }
  },
  mounted () {
    this.getChart()
  }
}
</script>
